import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const pinDeviceToDashboard = async (type: string, unitId: string): Promise<boolean> =>
  axios
    .post(`/dashwidget/pinunit`, {
      type,
      unitId
    })
    .then((res) => res?.data?.result)

type Props = {
  // user id or company id
  type: 'Account' | 'Company'
  unitId: string
}

export const usePinDeviceToDashboard = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['pinDeviceToDashboard'],
    mutationFn: ({ type, unitId }: Props) => pinDeviceToDashboard(type, unitId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Pinned to dashboard.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to pin to dashboard, please try again.')
      }
    },
    throwOnError: false
  })
